// extracted by mini-css-extract-plugin
export default {"wrapper":"gC-z","button":"hC-z","alternate":"iC-z","disabled":"jC-z","paymentWarning":"kC-z","fadeIn":"lC-z"};